
import * as React from 'react';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';

export const SideBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: -5,
    top: 19,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
  },
}));
